// Greenhold <Slider> primitive. Story 2.2.
//
// First shadcn primitive added to @greenhold/components since the
// Story 1.3 foundation. Backs the admin portfolio composer's per-tier
// probability knobs per UX-DR11.
//
// Styling: Greenhold tokens via Tailwind classes — forest-200 track,
// forest-700 active range, white-with-forest-700-ring thumb.

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "../lib/utils";

export type SliderProps = React.ComponentPropsWithoutRef<
  typeof SliderPrimitive.Root
>;

export const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-brand-forest-200">
      <SliderPrimitive.Range className="absolute h-full bg-brand-forest-700" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className={cn(
        "block h-5 w-5 rounded-full border-2 border-brand-forest-700 bg-white shadow-sm",
        "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-forest-700 focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",
      )}
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;
